export default {
    top_menu: [
        {name:'Peaasi',    id:0},
        {name:'Meelelahutusäri', id:1},
        {name:'Kokkamine',  id:2},
        {name:'Poliitika',   id:3},
        {name:'+18',  id:4},
        {name:'Ühiskond',   id:5},
        {name:'Tervis',   id:6},
    ],
    read_other: 'Loe rohkem',
    read_more:  'Rohkem detaile',
    not_found:  'Ei leitud midagi',
    read_also:  'Loe ka',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Kõik õigused kaitstud.',
    subscribe: 'Tellima',

    thank_order: 'AITÄH Teie tellimuse eest',
    specialist_contact: 'Meie spetsialist võtab teiega peagi ühendust, oodake meie kõnet.',
    attention: 'Soodustused partneritelt:',
    hurry: 'Kiirustage, allahindluse aktiveerimise aeg on piiratud! Nende ainulaadsete toodete valimiseks on teil aega vaid <span id="time" class="time">30:00</span> minutit:',

    hour_ago1: "Tund aega tagasi",
    hour_ago2: "tundi tagasi",
    hour_ago3: "tundi tagasi",
    new_publications: "Uued väljaanded",
    read: "Loe",
    today_at: "Täna kl",
    author_names: ['Johan Elm','Milena Bezborodova','Natalia Saiko'],
    main_news: "Peamised uudised",
    leave_already: "Juba lahkuda? Oota, oleme teie jaoks uudiseid värskendanud",
    already_shared: "juba jagatud"

}